import api from "./api";

// Spotlights — the circular picks in a "Discover" rail. A caption plus two crops
// (360x600 portrait, 320x320 circle) stored per language in m_images_lang, the
// same way banner artwork is: see m_spotlight on the API side.
const spotlightService = {
  getSpotlights: (params = {}) => {
    const qs = new URLSearchParams();
    if (params.perPage) qs.append("perPage", params.perPage);
    if (params.currentPage) qs.append("currentPage", params.currentPage);
    if (params.searchText) qs.append("searchText", params.searchText);
    if (params.status) qs.append("status", params.status);
    const query = qs.toString();
    return api.get(`/admin/spotlight${query ? `?${query}` : ""}`);
  },

  getSpotlightById: (id) => api.get(`/admin/spotlight/${id}`),

  createSpotlight: (payload) => api.post(`/admin/spotlight`, payload),

  updateSpotlight: (id, payload) => api.put(`/admin/spotlight/${id}`, payload),

  deleteSpotlight: (id) => api.delete(`/admin/spotlight/${id}`),
};

export default spotlightService;
